import { render, staticRenderFns } from "./BaseNotionLink.vue?vue&type=template&id=0ec77078&scoped=true"
import script from "./BaseNotionLink.vue?vue&type=script&lang=js"
export * from "./BaseNotionLink.vue?vue&type=script&lang=js"
import style0 from "./BaseNotionLink.vue?vue&type=style&index=0&id=0ec77078&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec77078",
  null
  
)

export default component.exports